export default "__VITE_ASSET__BXvFCPlD__"